import {chainWalk, deepCopyObject} from "../../../util/Util";
import {ADTF_ASSET_TYPE, ASSET_CONFIG_ATTRIBUTES} from "../../../util/Constants";

const ADTF_CONFIG_ATTRIBUTES = ASSET_CONFIG_ATTRIBUTES[ADTF_ASSET_TYPE];

export const updateConfigurationsInAdtfAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_CONFIG] =
        chainWalk(() => JSON.stringify(configurations.sorterConfig), "[]")
    updatedAsset.assetDetails.assetAttributes[ADTF_CONFIG_ATTRIBUTES.SORTER_TEST_PACKAGE] =
        chainWalk(() => JSON.stringify(configurations.sorterTestPackage), "[]")
    return updatedAsset;
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/datamodel/AdtfAssetModelResource.js